module.exports = __webpack_public_path__ + "static/media/Auftrag.01782cd6.pdf";